import React from "react";
import { Wrapper } from "./Memostyles";

const Memo = () => {
   return (
      <>
         <Wrapper>
            <h3>DENUKAN NETWORK LIMITED</h3>
            <h3>RC NO: 1513337</h3>
            <h3>MEMORANDUM OF ASSOCIATION AND ARTICLE OF ASSOCIATION</h3>
            <br />
            <h4>
               At the virtual Extraordinary General Meeting of Denukan Netowrk
               Limited (“the Company”) held on the 30th day of August 2022, the
               following was unanimously resolved:
            </h4>
            <ol>
               <li>
                  That the entire object Clause of the Company numbering 3 (1-6)
                  be and is hereby deleted and the same is replaced by the
                  following Clauses which shall number{" "}
                  <strong>Clauses 3 1- 20. (3)</strong>
                  <ol className="sub">
                     <li>Networking and general financial services.</li>
                     <li>
                        To provide consultancy and business advisory services to
                        Microfinance Banks, Banking institutions, and mortgage
                        houses, and to provide financial technology services.
                     </li>
                     <li>
                        To set up establish, work, manage, and maintain
                        telecommunication systems whether in respect of
                        telephony, telegraphy, radio, television, or otherwise.
                     </li>
                     <li>
                        To carry on the business of entertainment in all spheres
                        such as the production of movies, sports, and musical
                        content, and to act as representatives and managers of
                        artists in the entertainment industry.
                     </li>
                     <li>
                        To engage in the production of media content for the
                        purposes of providing general entertainment services. To
                        act as media consultants, and publicity agents and to
                        advertise, publicize and promote any person, production,
                        event, or thing whatsoever. To produce, process,
                        prepare, alter, develop, edit, display, print, convert,
                        distribute, import, and export, cine films, motion
                        pictures, tv serials, etc.
                     </li>
                     <li>
                        To carry on business as telecommunication engineers and
                        technicians.
                     </li>
                     <li>
                        To act as consultants, developers of core banking
                        applications, software developers, sale, supply, and
                        servicing of Automated Teller Machines (ATM), inverters
                        and solar panels, internet service providers, access
                        point sales and service, supply, and installation of
                        CCTV systems as well as providers of Information
                        Technology (IT) support services.
                     </li>
                     <li>
                        To carry on the business of sale and supply of computers
                        and accessories, marketing of computer software and
                        hardware, supply of smoke detectors, electric security
                        fence, and embedded systems.
                     </li>
                     <li>
                        To provide technology software platform services,
                        branding services, software development services to
                        individuals, businesses, companies, and organizations,
                        and to undertake information technology software
                        solutions and marketing services and enter into
                        arrangements and partnerships with private and public
                        companies for the purposes of promoting the use of the
                        services offered by the company.
                     </li>
                     <li>
                        To carry on the business of land and property
                        acquisition, project management and supervision, real
                        estate development, and management, general contracts
                        and merchants.
                     </li>
                     <li>
                        To build and manage agent networks and provide all kinds
                        of third-party services.
                     </li>
                     <li>
                        To develop, service, and sell/lease data based through
                        direct or electronic media, to develop a wide area of a
                        communication network, to develop service, buy/sell
                        computer, software, peripherals and related products and
                        to provide general marketing services.
                     </li>
                     <li>
                        To set up and run electronic data processing
                        platforms/centers and to carry on the business of data
                        processing, word processing, software consultancy,
                        system studies, management consultancy, techno-economic
                        information systems.
                     </li>
                     <li>
                        To acquire all licenses and powers required to carry out
                        the objects of the company.
                     </li>
                     <li>
                        To engage in the financing of hire-purchase
                        transactions, and to enter all contracts and arrangement
                        necessary therefore in achieving this objective.
                     </li>
                     <li>
                        To purchase or otherwise acquire any equipment or
                        property and to lease the same to any person or persons
                        upon any terms whatsoever.
                     </li>
                     <li>
                        To generally facilitate the sale, purchase and
                        acquisition of goods and property by providing
                        technology platforms and services suited appropriately
                        as necessity and expediency may require.
                     </li>
                     <li>
                        To carry on the businesses of supplying, operating,
                        managing, advising on, and dealing in services and
                        facilities for or in relation to communication apparatus
                        and equipment.
                     </li>
                     <li>
                        To carry on the business of manufacturing, running,
                        operating, managing, advising on and supplying data
                        processing and information retrieval systems on and
                        systems (whether or not remotely located and including
                        but not limited to videotext, teletex and teletex
                        systems) and systems utilizing the capture, storage,
                        processing, transmission or receipt of messages and
                        signals (including but not limited to data, sounds and
                        visual images) by, with the aid of, in conjunction with,
                        or in any utilizing computers. Or similar equipment, and
                        facilities of all kinds which incorporate, use or, are
                        used in conjunction with, in connection or any of the
                        apparatus and equipment comprised therein.
                     </li>
                     <li>
                        To do all such other things as may be considered
                        incidental or conducive to the attainment of the above
                        objects or any of them.
                     </li>
                  </ol>
               </li>
               <li>
                  That the company’s share capital be and is hereby altered to
                  reflect the new share capital of N100,000,000 (One hundred million
                  Naira) divided into 100,000,000,000 Ordinary shares of N1.00
                  each.
               </li>
               <li>
                  That the necessary filings to effect the above changes be
                  filed at the Corporate Affairs Commission.
               </li>
            </ol>
            <br />
            <h4 className="h4">Dated this 30th day of August 2022</h4>
         </Wrapper>
      </>
   );
};

export default Memo;
